import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, MapPin } from "lucide-react";
import Logo from "../components/Logo";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#F3F7F5] border-t border-[#E5EBE7] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo size={40} className="mb-4" />
            <p className="text-[#4B5563] max-w-md leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4 text-[#0A2518]">{t("footer.navigation")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-[#4B5563] hover:text-[#16A34A]">{t("nav.home")}</Link></li>
              <li><Link to="/parents" className="text-[#4B5563] hover:text-[#16A34A]">{t("nav.parents")}</Link></li>
              <li><Link to="/educators" className="text-[#4B5563] hover:text-[#16A34A]">{t("nav.educators")}</Link></li>
              <li><Link to="/about" className="text-[#4B5563] hover:text-[#16A34A]">{t("nav.about")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-semibold mb-4 text-[#0A2518]">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm text-[#4B5563]">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-[#16A34A]" />
                <a
                  href="mailto:contacts@monrepetiteur.org"
                  className="hover:text-[#16A34A] transition-colors"
                  data-testid="footer-email"
                >
                  contacts@monrepetiteur.org
                </a>
              </li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#16A34A]" /> {t("footer.city")}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#E5EBE7] mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-[#4B5563]">
          <p>{t("footer.rights", { year: new Date().getFullYear() })}</p>
          <p className="mt-2 sm:mt-0 flex items-center gap-1.5" data-testid="footer-ngo-credit">
            {t("footer.ngo")}
            <span className="font-display font-semibold text-[#0A422D]">{t("footer.ngoName")}</span>
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#10B981]" aria-hidden />
          </p>
        </div>
      </div>
    </footer>
  );
}
